import { useTranslation } from 'react-i18next'

import { REQUIREMENTPROFILE } from 'constants/evaluation-types'
import trackEvents from 'constants/track-events'
import { useNotificationContext } from 'context'
import { notifyBugsnag } from 'helpers'
import { trackEvent } from 'helpers/analytics'
import { useCallback } from 'react'
import { query } from '../../../graphql'
import { openPdfLoadingWindow } from '../../../helpers/pdf-loading'

export const useRequirementProfileDownload = ({
  careerId,
  language,
  hasCompletedOnboarding,
  notifySuccess,
  notifyError
}) => {
  const { t } = useTranslation()
  const { success, error } = useNotificationContext()

  const downloadRequirementProfile = useCallback(async () => {
    if (!hasCompletedOnboarding) return
    const pdfTab = openPdfLoadingWindow({ t, language })

    try {
      const pdfResponse = await query({
        query: 'generatePdf',
        variables: { career_id: careerId, language, type: REQUIREMENTPROFILE }
      })

      pdfTab.location.href = JSON.parse(pdfResponse).headers.Location
      success(t('pdf_success'))
      trackEvent(trackEvents.PREVIEW_REQUIREMENT_PROFILE, {
        diagnostic_version: 2
      })
    } catch (err) {
      error()
      notifyBugsnag(err)
      pdfTab.close()
    }
  }, [
    careerId,
    language,
    hasCompletedOnboarding,
    notifySuccess,
    notifyError,
    t
  ])

  return { downloadRequirementProfile }
}
